/**
 * HomeOfficeCalculatorPage — Batch #14.116
 *
 * Page dédiée pour la Calculatrice Bureau à domicile (T777).
 * Pointée par Cabinet Hub > tuile « Calculatrice bureau à domicile ».
 *
 * Note : `/admin/t777-submissions` reste utilisé séparément pour les
 * soumissions reçues depuis le portail (file PMS).
 */
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FISCAL_YEARS } from "@/constants/modules";
import { useFiscalYear } from "@/contexts/FiscalYearContext";
import { Home } from "lucide-react";
import T777Tab from "./expenses/T777Tab.jsx";

const DEFAULT_YEAR = FISCAL_YEARS[0] || new Date().getFullYear() - 1;

export default function HomeOfficeCalculatorPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { year: globalYear, setYear: setGlobalYear } = useFiscalYear();

  const [year, setYearLocal] = useState(() => {
    const urlYear = searchParams.get("year");
    return urlYear ? Number(urlYear) : (globalYear || DEFAULT_YEAR);
  });

  const setYear = (y) => {
    setYearLocal(y);
    setGlobalYear(y);
    setSearchParams({ year: String(y) });
  };

  return (
    <div className="space-y-4 p-4 sm:p-6 max-w-6xl mx-auto" data-testid="home-office-calculator">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-50 via-indigo-50 to-white border-2 border-indigo-200 rounded-2xl p-5 sm:p-6 shadow-sm flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center shadow">
          <Home className="w-6 h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <h1 className="text-lg sm:text-xl font-bold text-slate-900">
            Calculatrice bureau à domicile
          </h1>
          <p className="text-xs text-slate-600 mt-0.5">
            Dépenses d'emploi et bureau à domicile — calcul de la déduction admissible.
          </p>
        </div>
        <div>
          <label className="text-[11px] font-semibold text-slate-600 uppercase tracking-wider block mb-1">
            Année fiscale
          </label>
          <select
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
            className="px-3 py-1.5 rounded-lg border border-slate-300 text-sm focus:ring-2 focus:ring-indigo-300"
            data-testid="home-office-year-select"
          >
            {FISCAL_YEARS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>

      {/* Calculatrice */}
      <T777Tab year={year} />
    </div>
  );
}
